var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.812 0.609997C13.6934 0.513622 13.5372 0.476778 13.388 0.510012L0.388054 3.51001C0.159257 3.56261 -0.00218085 3.76726 2.22753e-05 4.00201V21.002C0.000116025 21.2487 0.180163 21.4585 0.424007 21.496L13.424 23.4961C13.6969 23.538 13.9522 23.3508 13.9942 23.0779C13.998 23.0528 14 23.0275 14 23.0021V1.00201C14.0005 0.849528 13.9312 0.7052 13.812 0.609997Z",
    fill: "rgb(51,108,57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.5019H13.5C13.2239 21.5019 13 21.2781 13 21.0019C13 20.7258 13.2239 20.5019 13.5 20.5019H23V3.50194H13.5C13.2239 3.50194 13 3.27806 13 3.00192C13 2.72578 13.2239 2.50195 13.5 2.50195H23.5C23.7761 2.50195 24 2.72583 24 3.00197V21.002C24 21.2781 23.7762 21.5019 23.5 21.5019Z",
    fill: "rgb(51,108,57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49999 16.5016C9.32758 16.5016 9.16736 16.4128 9.076 16.2667L4.07599 8.26664C3.92228 8.03723 3.98369 7.72664 4.2131 7.57294C4.4425 7.41923 4.7531 7.48064 4.9068 7.71005C4.91285 7.71905 4.91857 7.72823 4.924 7.73761L9.92402 15.7376C10.0698 15.9721 9.99789 16.2804 9.76338 16.4263C9.6843 16.4754 9.59308 16.5015 9.49999 16.5016Z",
    fill: "#FFFFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49996 16.5017C4.22382 16.5011 4.00042 16.2768 4.00098 16.0007C4.00117 15.9073 4.02751 15.8158 4.07696 15.7367L9.07698 7.73667C9.21545 7.49775 9.5214 7.41632 9.76027 7.55479C9.9992 7.69326 10.0806 7.99921 9.94215 8.23809C9.93671 8.24746 9.93099 8.25665 9.92495 8.26565L4.92498 16.2657C4.83367 16.4125 4.67293 16.5018 4.49996 16.5017Z",
    fill: "#FFFFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.502C17.2239 21.502 17 21.2781 17 21.002V3.00197C17 2.72583 17.2239 2.50195 17.5 2.50195C17.7762 2.50195 18 2.72583 18 3.00197V21.002C18 21.2782 17.7762 21.502 17.5 21.502Z",
    fill: "rgb(51,108,57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18.502H13.5C13.2239 18.502 13 18.2781 13 18.002C13 17.7258 13.2239 17.502 13.5 17.502H23.5C23.7761 17.502 24 17.7258 24 18.002C24 18.2782 23.7762 18.502 23.5 18.502Z",
    fill: "rgb(51,108,57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.502H13.5C13.2239 15.502 13 15.2781 13 15.002C13 14.7258 13.2239 14.502 13.5 14.502H23.5C23.7761 14.502 24 14.7258 24 15.002C24 15.2782 23.7762 15.502 23.5 15.502Z",
    fill: "rgb(51,108,57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.502H13.5C13.2239 12.502 13 12.2781 13 12.002C13 11.7258 13.2239 11.502 13.5 11.502H23.5C23.7761 11.502 24 11.7258 24 12.002C24 12.2782 23.7762 12.502 23.5 12.502Z",
    fill: "rgb(51,108,57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 9.50198H13.5C13.2239 9.50198 13 9.27811 13 9.00197C13 8.72583 13.2239 8.50195 13.5 8.50195H23.5C23.7761 8.50195 24 8.72583 24 9.00197C24 9.27811 23.7762 9.50198 23.5 9.50198Z",
    fill: "rgb(51,108,57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6.50198H13.5C13.2239 6.50198 13 6.2781 13 6.00197C13 5.72583 13.2239 5.50195 13.5 5.50195H23.5C23.7761 5.50195 24 5.72583 24 6.00197C24 6.27815 23.7762 6.50198 23.5 6.50198Z",
    fill: "rgb(51,108,57)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.7072dc5c8b8a7e9ef7e6b1bdee802b57.svg";
export { ForwardRef as ReactComponent };